<template>
  <div class="form-container">
    <div>
      <b-modal
        id="subscribe"
        class="text-left"
        hide-footer
        ref="signUpModalRef"
      >
        <h1 class="modal-title text-center1">GET EARLY INVITATION</h1>

        <div id="mc_embed_signup">
          <form
            action="https://xyz.us11.list-manage.com/subscribe/post?u=bef4ab5946bf356635c74ac31&amp;id=b0f5f5964d"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            novalidate
          >
            <div id="mc_embed_signup_scroll">
              <div class="mc-field-group form-group">
                <label for="mce-FNAME">Name</label>
                <input
                  type="text"
                  value=""
                  name="FNAME"
                  class="form-control"
                  id="mce-FNAME"
                  aria-describedby="nameHelp"
                />
              </div>

              <div class="mc-field-group form-group">
                <label for="mce-EMAIL">Email Address</label>
                <input
                  type="email"
                  value=""
                  name="EMAIL"
                  class="required email form-control"
                  id="mce-EMAIL"
                />
              </div>

              <div class="mc-field-group input-group form-group form-check">
                <input
                  type="checkbox"
                  value="1"
                  name="group[18749][1]"
                  id="mce-group[18749]-18749-0"
                  class="form-check-input"
                />
                <label for="mce-group[18749]-18749-0" class="form-check-label"
                  >I'm a Stylist</label
                >
              </div>

              <div id="mce-responses" class="clear">
                <div
                  class="response"
                  id="mce-error-response"
                  style="display:none"
                ></div>
                <div
                  class="response"
                  id="mce-success-response"
                  style="display:none"
                ></div>
              </div>
              <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->

              <div
                style="position: absolute; left: -5000px;"
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="b_bef4ab5946bf356635c74ac31_b0f5f5964d"
                  tabindex="-1"
                  value=""
                />
              </div>

              <hr />

              <div class="clear">
                <button
                  type="submit"
                  value="Subscribe"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  class="button btn btn-unstitched float-right"
                >
                  Get Access
                </button>
              </div>
            </div>
          </form>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  mounted() {
    bus.$on("openSignUpModal", () => {
      if (this.$refs.signUpModalRef) this.$refs.signUpModalRef.show();
    });
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

#subscribe {
  .modal-title {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }

  .form-control {
    border-radius: 0;

    &:focus {
      border-color: $primary-blue;
    }
  }

  .modal-header {
    min-height: 150px;
    background-image: url("~@/assets/img/stylists2.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
  }
}

.btn-sign-up-form {
  padding: 15px;
  border-radius: 0;

  &.btn-modal {
    margin-right: 15px !important;
  }
}

.form-container {
  .btn {
    font-weight: 400;
    text-transform: uppercase;
    font-size: 1rem;
    border-radius: 0;
  }

  .form-control:focus {
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/SignUpModal.vue